import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import en from "./locales/en.json";
import tr from "./locales/tr.json";

// If the URL contains ?lng=tr|en (used by admin preview iframes), we should
// honour it but NOT persist it to localStorage — otherwise opening the preview
// would silently change the user's normal language preference.
const hasUrlLang =
  typeof window !== "undefined" &&
  /[?&]lng=(tr|en)\b/i.test(window.location.search);

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      tr: { translation: tr },
    },
    // x-default / varsayılan dil zinciri: eksik bir anahtar TR'de yoksa EN,
    // EN'de de yoksa anahtarın kendisi yerine boş kalmasın diye zincir kurulu.
    fallbackLng: { tr: ["en"], en: ["tr"], default: ["en"] },
    supportedLngs: ["tr", "en"],
    nonExplicitSupportedLngs: true, // tr-TR / en-US → tr / en
    // Boş string'i "geçerli çeviri" saymayıp fallback diline düş.
    returnEmptyString: false,
    returnNull: false,
    parseMissingKeyHandler: (key) => {
      if (import.meta.env.DEV) console.warn(`[i18n] eksik çeviri: ${key}`);
      // Anahtar yolu yerine son segmenti okunabilir şekilde göster.
      return key.split(".").pop() ?? key;
    },
    interpolation: { escapeValue: false },
    detection: {
      // querystring first so admin preview iframes (?lng=tr / ?lng=en)
      // can pin a language independent of the parent window.
      order: ["querystring", "localStorage", "navigator"],
      lookupQuerystring: "lng",
      // Skip caching whenever the language was forced via URL.
      caches: hasUrlLang ? [] : ["localStorage"],
    },

  });

export default i18n;
